<template src="./Spinner.html"></template>
<script>
export default {
  name: "Spinner"
};
</script>
<style src="./Spinner.css"></style>
